module.exports = __webpack_public_path__ + "static/media/registerLockGuide2_Jap.d316267c.png";